module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"protrusion-formula":{"DEFAULT":"Covered on","FIRST":"Covered for the first time on","AVORTED":"Slipped","SANK":"Slipped","EMPTY":"Barren","NONE":"Not covered"}}}')
  delete Component.options._Ctor
}
